<template>
  <v-card class="mx-auto" :loading="loading" :disabled="loading">
    <v-card-title>
      <v-row>
        <v-col cols="12" md="8">
          <BtnCircle
            tLabel="Atrás"
            tPosition="bottom"
            icon="mdi-arrow-left"
            color="grey darken-3"
            size="x-small"
            :to="{
              name: `${page_route}${store_mode ? '' : '.view'}`,
              params: { id: id },
            }"
          />
          <span class="text-h6 ml-1" v-text="$route.meta.title" />
        </v-col>

        <v-col cols="12" md="4" class="text-right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                fab
                x-small
                class="ml-1"
                color="info"
                @click.stop="faqs_dlg = true"
                :loading="faqs_ldg"
                :disabled="faqs.length == 0"
              >
                <v-icon> mdi-help </v-icon>
              </v-btn>
            </template>
            <span v-text="'Ayuda'" />
          </v-tooltip>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text v-if="!loading">
      <v-form ref="form_data" lazy-validation>
        <v-row>
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption" v-text="'GENERAL'" />
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Nombre*"
                      v-model="data.name"
                      :rules="rules.text100Required"
                      type="text"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Nombre de comercial*"
                      v-model="data.trade_name"
                      :rules="rules.text100Required"
                      type="text"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-autocomplete
                      label="Tipo de proveedor*"
                      v-model="data.provider_type_id"
                      :rules="rules.required"
                      :items="provider_types"
                      item-value="id"
                      :item-text="(item) => item.provider_type"
                      :loading="provider_types_ldg"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-autocomplete
                      label="Concentrador*"
                      v-model="data.provider_brand_id"
                      :items="provider_brands"
                      item-value="id"
                      :item-text="(item) => item.provider_brand"
                      :loading="provider_brands_loading"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-select
                      label="Formato de estado de cuenta*"
                      v-model="data.status_account_format_id"
                      :items="status_account_formats"
                      item-value="id"
                      :item-text="(item) => item.status_account_format"
                      :loading="status_account_formats_loading"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-autocomplete
                      label="Provider Type"
                      v-model="data.provider_type_detail_id"
                      :items="provider_type_details"
                      item-value="id"
                      :item-text="(v) => v.name"
                      :loading="provider_type_details_ldg"
                      :rules="rules.required"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-autocomplete
                      label="Provider Specialty"
                      v-model="data.provider_specialty_id"
                      :items="provider_specialties"
                      item-value="id"
                      :item-text="(v) => v.name"
                      :loading="provider_specialties_ldg"
                      :rules="rules.required"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'IP'"
                      v-model="data.ip"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'OP'"
                      v-model="data.op"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-switch
                      class="mt-0"
                      label="Usuario sistema"
                      v-model="data.user.active"
                    />
                  </v-col>

                  <v-col v-if="data.user.active" cols="12" md="4">
                    <v-text-field
                      label="Correo electrónico"
                      v-model="data.user.email2"
                      :rules="rules.email"
                      type="text"
                      dense
                      counter
                      maxlength="90"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      :label="'RFC' + (data.user.active ? '' : '*')"
                      v-model="data.code_tax"
                      :rules="
                        data.user.active
                          ? rules.code_tax_sat
                          : rules.code_tax_sat_opt
                      "
                      type="text"
                      dense
                      counter
                      maxlength="13"
                    />
                  </v-col>

                  <v-col cols="12" md="3" class="pb-4">
                    <span class="text-caption" v-text="'Evidencia (PDF)'" />
                    <br />
                    <input
                      accept=".pdf"
                      type="file"
                      @change="selectFile($event, 0, 'proof')"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      v-model="data.observation"
                      label="Observación"
                      dense
                      rows="1"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- TIPO DE PROVEEDOR -->
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption" v-text="'TIPO DE PROVEEDOR'" />
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    v-for="(
                      provider_provider_type, i
                    ) in data.provider_provider_types"
                    :key="i"
                  >
                    <v-row v-if="provider_provider_type.active" dense>
                      <v-col cols="11">
                        <v-autocomplete
                          label="Tipo"
                          v-model="provider_provider_type.provider_type_id"
                          :item-text="(item) => item.provider_type"
                          item-value="id"
                          :items="provider_types"
                          :loading="provider_types_ldg"
                          :rules="rules.required"
                          dense
                        />
                      </v-col>

                      <v-col cols="1" class="text-center" align-self="center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              text
                              icon
                              x-small
                              color="error"
                              @click="providerProviderTypeRemove(i)"
                            >
                              <v-icon medium v-text="'mdi-close'" />
                            </v-btn>
                          </template>
                          <span v-text="`Eliminar (${i + 1})`" />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12">
                    <v-btn
                      @click="providerProviderTypeAdd()"
                      color="warning"
                      x-small
                      block
                      dark
                    >
                      <v-icon left v-text="'mdi-plus'" />
                      Agregar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- BANCO -->
          <v-col cols="12">
            <v-card
              class="mx-auto"
              :disabled="login.role_id != 1 && login.role_id != 15"
            >
              <v-card-title>
                <h2 class="text-caption" v-text="'BANCO'" />
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="4">
                    <v-autocomplete
                      label="Banco"
                      v-model="data.bank_id"
                      :items="banks"
                      item-value="id"
                      :item-text="(v) => v.bank"
                      :loading="banks_loading"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      label="Número de cuenta"
                      v-model="data.account_number"
                      type="text"
                      maxlength="15"
                      counter
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      label="CLABE"
                      v-model="data.clabe"
                      type="text"
                      maxlength="18"
                      counter
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-switch
                      class="mt-0 pt-0"
                      v-model="data.discount"
                      :label="'Descuento'"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <span
                      class="text-caption"
                      v-text="'Cuenta bancaria (PDF)'"
                    />
                    <br />
                    <input
                      accept=".pdf"
                      type="file"
                      @change="selectFile($event, 0, 'bank_account')"
                    />
                  </v-col>

                  <v-col cols="12" md="4">
                    <span class="text-caption" v-text="'Valid. cuenta (PDF)'" />
                    <br />
                    <input
                      accept=".pdf"
                      type="file"
                      @change="selectFile($event, 0, 'account_validation')"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- DOMICILIO -->
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption" v-text="'DOMICILIO'" />
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Calle"
                      v-model="data.street"
                      :rules="rules.text100"
                      type="text"
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Número exterior"
                      v-model="data.external_number"
                      :rules="rules.text20"
                      type="text"
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Número interior"
                      v-model="data.internal_number"
                      :rules="rules.text20"
                      type="text"
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Colonia"
                      v-model="data.suburb"
                      :rules="rules.text50"
                      type="text"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-autocomplete
                      label="Estado*"
                      v-model="data.entity_id"
                      :rules="rules.required"
                      :items="entities"
                      item-value="id"
                      :item-text="(item) => item.entity"
                      :loading="entities_loading"
                      v-on:change="getMunicipalities()"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-autocomplete
                      label="Municipio*"
                      v-model="data.municipality_id"
                      :rules="rules.required"
                      :items="municipalities"
                      item-value="id"
                      :item-text="(item) => item.municipality"
                      :loading="municipalities_loading"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Código postal"
                      v-model="data.zip"
                      :rules="rules.text5"
                      type="text"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <span
                      class="text-caption"
                      v-text="'Comp. domicilio (PDF)'"
                    />
                    <br />
                    <input
                      accept=".pdf"
                      type="file"
                      @change="selectFile($event, 0, 'address')"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- LEGAL -->
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption" v-text="'LEGAL'" />
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Razón social"
                      v-model="data.legal_name"
                      :rules="rules.text100"
                      type="text"
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Domicilio fiscal"
                      v-model="data.legal_address"
                      :rules="rules.text150"
                      type="text"
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <span class="text-caption" v-text="'RFC (PDF)'" />
                    <br />
                    <input
                      accept=".pdf"
                      type="file"
                      @change="selectFile($event, 0, 'code_tax')"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- CONTACTO -->
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption" v-text="'CONTACTO'" />
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="6">
                    <v-text-field
                      label="Nombre de contacto"
                      v-model="data.contact_name"
                      :rules="rules.text100"
                      type="text"
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Ext. pais (+)"
                      v-model="data.phone_ext"
                      :rules="rules.required"
                      type="text"
                      dense
                    />
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Teléfono"
                      v-model="data.phone"
                      :rules="rules.phone_rqd"
                      type="text"
                      dense
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- OTROS -->
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption" v-text="'OTROS'" />
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-text-field
                      label="IVA"
                      v-model="data.iva"
                      :rules="rules.required"
                      type="number"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Día de pago*"
                      v-model="data.pay_day"
                      type="number"
                      dense
                      :rules="rules.required"
                      min="1"
                      max="31"
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Factor CPT"
                      v-model="data.cpt_factor"
                      type="number"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field
                      label="NET ID"
                      v-model="data.net_id"
                      min="1"
                      type="number"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Descuento en factura'"
                      v-model="data.bill_discount"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-select
                      :label="`Tipo de descuento*`"
                      v-model="data.fixed_discount"
                      :items="discounts"
                      item-value="id"
                      :item-text="(item) => item.discount"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Porcentaje de descuento"
                      v-model="data.fund_without_discount"
                      type="number"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-autocomplete
                      label="Formato DDC en factura*"
                      v-model="data.ddc_format"
                      :items="ddc_formats"
                      item-value="id"
                      :item-text="(v) => v.name"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Sin Nota de crédito o posterior'"
                      v-model="data.credit_note_after"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Descuento, deducible y coaseguro'"
                      v-model="data.ddc"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      label="Monto exento"
                      v-model="data.exempt_amount"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'IVA, deducible y coaseguro'"
                      v-model="data.idc"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Convenio'"
                      v-model="data.agreement"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3" v-if="login.role_id === 1">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Segunda firma red'"
                      v-model="data.revision"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field
                      label="C.S."
                      v-model="data.cs"
                      maxlength="10"
                      type="text"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Sumar deducible y coseguro'"
                      v-model="data.add_deductible_coinsurance"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'No verificar monto nota de crédito'"
                      v-model="data.notes_verify_amount"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Aumento de suma automático'"
                      v-model="data.automatic_authorization"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-text-field
                      label="Porc. cobro particulares"
                      v-model="data.particular_payment"
                      type="number"
                      min="0"
                      max="99"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Envio correos cobro particulares'"
                      v-model="data.service_particular_email"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Generar carta servicio automáticamente'"
                      v-model="data.auto_letter_generated"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Módulo SM'"
                      v-model="data.with_module"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Auto confirmar servicios'"
                      v-model="data.rs_service_auto_confirm"
                      dense
                    />
                  </v-col>

                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Pase para servicios'"
                      v-model="data.has_service_pass"
                      dense
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- INFO | REVISIÓN DE CARTERA -->
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2
                  class="text-caption"
                  v-text="'INFO | REVISIÓN DE CARTERA'"
                />
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      label="Mostrar mensaje"
                      v-model="data.show_collection_review_message"
                      dense
                    />
                  </v-col>

                  <v-col v-if="data.show_collection_review_message" cols="12">
                    <v-textarea
                      v-model="data.collection_review_message"
                      label="Mensaje"
                      dense
                      rows="2"
                      :rules="rules.required"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- CONDICIONES HOSPITALES SEDE -->
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption">CONDICIONES HOSPITALES SEDE</h2>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row dense>
                  <v-col cols="12" md="3">
                    <v-switch
                      class="mt-0 pt-0"
                      :label="'Activo'"
                      v-model="data.express_letter"
                      dense
                    />
                  </v-col>

                  <v-col v-if="data.express_letter" cols="12" md="3">
                    <v-text-field
                      label="Monto"
                      v-model="data.express_amount"
                      :rules="rules.required"
                      type="number"
                      dense
                    />
                  </v-col>

                  <v-col v-if="data.express_letter" cols="12">
                    <v-textarea
                      v-model="data.express_caption"
                      label="Observación"
                      dense
                      rows="1"
                    />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- FACTURAS -->
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption" v-text="'FACTURAS'" />
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    v-for="(item, i) in data.invoices_receptions"
                    :key="i"
                  >
                    <v-row v-if="item.active" dense>
                      <v-col cols="12" md="5">
                        <v-select
                          :label="`Día de recepción* (${i + 1})`"
                          v-model="item.day_id"
                          :rules="rules.required"
                          :items="days"
                          item-value="id"
                          :item-text="(item) => item.day"
                          :loading="days_loading"
                          dense
                        />
                      </v-col>

                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="item.start"
                          label="Hora de inicio*"
                          :rules="rules.required"
                          type="time"
                          dense
                        />
                      </v-col>

                      <v-col cols="12" md="3">
                        <v-text-field
                          v-model="item.end"
                          label="Hora de término*"
                          :rules="rules.required"
                          type="time"
                          dense
                        />
                      </v-col>

                      <v-col
                        cols="12"
                        md="1"
                        class="text-center"
                        align-self="center"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              text
                              icon
                              x-small
                              color="error"
                              @click="deleteInvoiceReception(i)"
                            >
                              <v-icon medium v-text="'mdi-close'" />
                            </v-btn>
                          </template>
                          <span
                            v-text="`Eliminar día de recepción (${i + 1})`"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12">
                    <v-btn
                      @click="addRecepcion"
                      color="warning"
                      :loading="loading"
                      x-small
                      block
                      dark
                    >
                      <v-icon left v-text="'mdi-plus'" />
                      Agregar día de recepción
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- ENVIO DE CORREOS ELECTRÓNICOS -->
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2
                  class="text-caption"
                  v-text="'ENVIO DE CORREOS ELECTRÓNICOS'"
                />
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    v-for="(provider_email, i) in data.provider_emails"
                    :key="i"
                  >
                    <v-row v-if="provider_email.active" dense>
                      <v-col cols="5">
                        <v-text-field
                          v-model="provider_email.email"
                          :label="`Correo electrónico* (${i + 1})`"
                          :rules="rules.email"
                          type="text"
                          dense
                        />
                      </v-col>

                      <v-col cols="5">
                        <v-switch
                          class="mt-0 pt-0"
                          v-model="provider_email.for_service"
                          :label="
                            'Uso: ' +
                            (provider_email.for_service
                              ? 'Servicio particular'
                              : ' Carta ingresos')
                          "
                          dense
                        />
                      </v-col>

                      <v-col cols="2" align-self="center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              text
                              icon
                              x-small
                              color="error"
                              @click="emailDelete(i)"
                            >
                              <v-icon medium v-text="'mdi-close'" />
                            </v-btn>
                          </template>
                          <span
                            v-text="`Eliminar correo electrónico (${i + 1})`"
                          />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12">
                    <v-btn
                      @click="emailAdd"
                      color="warning"
                      :loading="loading"
                      x-small
                      block
                      dark
                    >
                      <v-icon left v-text="'mdi-plus'" />
                      Agregar correo electrónico
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- ASEGURADORAS -->
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption">ASEGURADORAS</h2>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    v-for="(provider_insurance, i) in data.provider_insurances"
                    :key="i"
                  >
                    <v-row v-if="provider_insurance.active" dense>
                      <v-col cols="3">
                        <v-autocomplete
                          label="Aseguradora"
                          v-model="provider_insurance.insurance_id"
                          :items="insurances"
                          item-value="id"
                          item-text="name"
                          :loading="insurances_loading"
                          dense
                          :rules="rules.required"
                        />
                      </v-col>

                      <v-col cols="4">
                        <v-switch
                          label="INFO Reporte Ing., Urg. y Serv."
                          v-model="provider_insurance.show_rhas"
                          class="mt-0 pt-0"
                          dense
                        />
                      </v-col>

                      <v-col cols="4">
                        <v-switch
                          label="INFO Facturación"
                          v-model="provider_insurance.show_bills"
                          class="mt-0 pt-0"
                          dense
                        />
                      </v-col>

                      <v-col cols="1" align-self="center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              text
                              icon
                              x-small
                              color="error"
                              @click="providerInsuranceDelete(i)"
                            >
                              <v-icon medium v-text="'mdi-close'" />
                            </v-btn>
                          </template>
                          <span v-text="`Eliminar aseguradora (${i + 1})`" />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12">
                    <v-btn
                      @click="providerInsuranceAdd"
                      color="warning"
                      :loading="loading"
                      x-small
                      block
                      dark
                    >
                      <v-icon left v-text="'mdi-plus'" />
                      Agregar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <!-- CONCENTRADOR -->
          <v-col cols="12">
            <v-card class="mx-auto">
              <v-card-title>
                <h2 class="text-caption">CONCENTRADOR</h2>
              </v-card-title>
              <v-divider />
              <v-card-text>
                <v-row>
                  <v-col
                    cols="12"
                    v-for="(provider_in_group, i) in data.provider_in_groups"
                    :key="i"
                  >
                    <v-row v-if="provider_in_group.active" dense>
                      <v-col cols="6">
                        <v-autocomplete
                          label="Nombre"
                          v-model="provider_in_group.provider_group_id"
                          :items="provider_groups"
                          item-value="id"
                          item-text="provider_group"
                          :loading="provider_groups_loading"
                          dense
                          :rules="rules.required"
                        />
                      </v-col>

                      <v-col cols="5">
                        <v-switch
                          label="APT = Alta Apertura Terminada"
                          v-model="provider_in_group.opening_discharge"
                          class="mt-0 pt-0"
                          dense
                        />
                      </v-col>

                      <v-col cols="1" align-self="center">
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              text
                              icon
                              x-small
                              color="error"
                              @click="providerInGroupDelete(i)"
                            >
                              <v-icon medium v-text="'mdi-close'" />
                            </v-btn>
                          </template>
                          <span v-text="`Eliminar concentrador (${i + 1})`" />
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12">
                    <v-btn
                      @click="providerInGroupAdd"
                      color="warning"
                      :loading="loading"
                      x-small
                      block
                      dark
                    >
                      <v-icon left v-text="'mdi-plus'" />
                      Agregar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" class="text-right">
            <BtnCircle
              :tLabel="store_mode ? 'Crear' : 'Editar'"
              tPosition="top"
              :icon="store_mode ? 'mdi-plus' : 'mdi-pencil'"
              :color="store_mode ? 'success' : 'info'"
              size="small"
              :click="handleSubmit"
              :loading="loading"
            />
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>

    <FaqDlg v-model="faqs_dlg" :faqs="faqs" />
  </v-card>
</template>

<script>
import Axios from "axios";
import {
  URL_API,
  headersToken,
  msgConfirm,
  msgAlert,
  rules,
  toFormData,
} from "../../control";
import { catalog } from "../../requests/catalogRequest";
import { show, index } from "../../requests/pageRequest";
import BtnCircle from "../../components/BtnCircle.vue";
import FaqDlg from "../../components/FaqDlg.vue";

export default {
  components: {
    BtnCircle,
    FaqDlg,
  },

  data() {
    return {
      page_route: "providers",
      id: this.$route.params.id ? Number(this.$route.params.id) : 0,
      store_mode: this.$route.params.id ? false : true,
      login: this.$store.getters.getLogin,

      loading: false,

      data: {
        id: null,
        name: "",
        street: "",
        external_number: "",
        internal_number: "",
        suburb: "",
        city: "",
        zip: "",
        legal_name: "",
        code_tax: "",
        legal_address: "",
        phone: "",
        phone_ext: "",
        trade_name: "",
        contact_name: "",
        account_number: "",
        clabe: "",
        discount: false,
        ddc: false,
        iva: 0,
        idc: false,
        pay_day: "1",
        agreement: false,
        exempt_amount: false,
        bill_discount: false,
        fund_with_discount: 0,
        fixed_discount: false,
        fund_without_discount: 0,
        cpt_factor: 1,
        provider_type_id: 9,
        provider_type_detail_id: null,
        provider_specialty_id: null,
        entity_id: null,
        municipality_id: null,
        invoices_receptions: [],
        net_id: null,
        cs: null,
        provider_brand_id: null,
        bank_id: null,
        ddc_format: null,
        credit_note_after: false,
        add_deductible_coinsurance: false,
        notes_verify_amount: false,
        automatic_authorization: false,
        express_letter: false,
        express_amount: 0,
        express_caption: "",
        provider_emails: [],
        service_particular_email: false,
        auto_letter_generated: false,
        with_module: false,
        rs_service_auto_confirm: false,
        ip: false,
        op: false,
        provider_provider_types: [],
        user_id: null,
        user: {
          id: null,
          active: true,
          email: null,
          email2: null,
        },
        provider_insurances: [],
        proof: null,
        has_service_pass: false,
        show_collection_review_message: false,
        collection_review_message: "",
        provider_in_groups: [],
      },

      rules: rules(),

      municipalities: [],
      municipalities_loading: false,

      entities: [],
      entities_loading: true,

      provider_types: [],
      provider_types_ldg: true,

      days: [],
      days_loading: true,

      status_account_formats: [],
      status_account_formats_loading: true,

      provider_brands: [],
      provider_brands_loading: true,

      banks: [],
      banks_loading: true,

      provider_type_details: [],
      provider_type_details_ldg: true,

      provider_specialties: [],
      provider_specialties_ldg: true,

      faqs: [],
      faqs_dlg: false,
      faqs_ldg: true,

      insurances: [],
      insurances_loading: true,

      provider_groups: [],
      provider_groups_loading: true,

      discounts: [
        { id: 0, discount: "Variable" },
        { id: 1, discount: "Fijo" },
      ],
      ddc_formats: [
        { id: null, name: "NINGUNO" },
        { id: 1, name: "ANGELES" },
        { id: 2, name: "OCA" },
      ],
      banks_default_item: { id: null, bank: "PENDIENTE" },
      provider_brand_default_item: { id: null, provider_brand: "NINGUNO" },
      status_account_format_default_item: {
        id: null,
        status_account_format: "NINGUNO",
      },
    };
  },

  methods: {
    // Files (PDFs)
    selectFile(event, i, fileKey) {
      const file = event?.target?.files?.[0] || null;
      const position = `document_${fileKey}_${i}`;
      this.$set(this.data, position, file);
    },

    // Municipios (dependen de entity_id)
    async getMunicipalities() {
      const entity_id = this.data.entity_id;

      if (!entity_id) {
        this.municipalities = [];
        return;
      }

      this.municipalities_loading = true;

      try {
        const resp = await index(
          `municipalities/${entity_id}`,
          this.login.token,
          [
            { name: "active", value: 1 },
            { name: "id", value: this.login.id },
          ],
        );

        this.municipalities = resp.data || [];
      } catch (e) {
        console.log(e);
        this.municipalities = [];
      } finally {
        this.municipalities_loading = false;
      }
    },

    // Validación: no permitir tipos duplicados (solo activos + con valor)
    hasDuplicateProviderTypes() {
      const ids = (this.data.provider_provider_types || [])
        .filter((t) => Number(t.active) === 1)
        .map((t) => Number(t.provider_type_id))
        .filter((v) => v > 0);

      return new Set(ids).size !== ids.length;
    },

    hasDuplicateProviderInGroups() {
      const ids = (this.data.provider_in_groups || [])
        .filter((r) => Number(r.active) === 1)
        .map((r) => Number(r.provider_group_id))
        .filter((v) => v > 0);

      return new Set(ids).size !== ids.length;
    },

    hasDuplicateProviderInsurances() {
      const ids = (this.data.provider_insurances || [])
        .filter((r) => Number(r.active) === 1)
        .map((r) => Number(r.insurance_id))
        .filter((v) => v > 0);

      return new Set(ids).size !== ids.length;
    },

    // Submit (mantiene comportamiento original, con returns tempranos)
    async handleSubmit() {
      if (!this.$refs.form_data.validate()) {
        this.$swal.fire(
          msgAlert(
            "error",
            "Formulario invalido, revisa los detalles señalados",
          ),
        );
        return;
      }

      if (this.hasDuplicateProviderTypes()) {
        this.$swal.fire(
          msgAlert("error", "No se pueden repetir tipos de proveedor"),
        );
        return;
      }

      if (this.hasDuplicateProviderInGroups()) {
        this.$swal.fire(
          msgAlert("error", "No se pueden repetir concentradores (grupos)"),
        );
        return;
      }

      if (this.hasDuplicateProviderInsurances()) {
        this.$swal.fire(msgAlert("error", "No se pueden repetir aseguradoras"));
        return;
      }

      if (parseInt(this.data.pay_day, 10) <= 0) {
        this.$swal.fire(
          msgAlert(
            "error",
            "El día de pago es obligatorio y debe ser mayor a cero",
          ),
        );
        return;
      }

      const confirm = await this.$swal.fire(
        msgConfirm(
          `¿Confirma la ${
            this.store_mode ? "creación" : "edición"
          } del registro?`,
        ),
      );

      if (!confirm.isConfirmed) return;

      this.loading = true;

      try {
        // Mantiene la misma regla de email interno
        this.data.user.email = (this.data.trade_name || "").replace(/\s+/g, "");

        const obj = { ...this.data, user: JSON.stringify(this.data.user) };
        const data_form = toFormData(obj);

        if (this.id) data_form.append("_method", "PATCH");

        const url = `${URL_API}/${this.page_route}${
          this.id ? `/${this.id}` : ""
        }`;

        const res = await Axios.post(
          url,
          data_form,
          headersToken(this.login.token),
        );

        this.$swal.fire(
          msgAlert(res.data.success ? "success" : "error", res.data.message),
        );

        if (res.data.success) {
          this.$router.push({
            name: `${this.page_route}${this.store_mode ? "" : ".view"}`,
            params: { id: this.id },
          });
        }
      } catch (e) {
        console.log(e);
        this.$swal.fire(
          msgAlert("error", "Error. Contacte al equipo de desarrollo"),
        );
      } finally {
        this.loading = false;
      }
    },

    // Facturas - recepciones
    addRecepcion() {
      this.data.invoices_receptions.push({
        id: null,
        start: "",
        end: "",
        day_id: 1,
        active: 1,
      });
    },

    deleteInvoiceReception(i) {
      this.$swal
        .fire(msgConfirm(`¿Confirma eliminar el día de recepción (${i + 1})?`))
        .then((resp) => {
          if (!resp.isConfirmed) return;

          const row = this.data.invoices_receptions[i];
          if (!row) return;

          if (row.id === null) this.data.invoices_receptions.splice(i, 1);
          else row.active = 0;
        });
    },

    // Provider Types (multi)
    providerProviderTypeAdd() {
      this.data.provider_provider_types.push({
        id: null,
        active: 1,
        provider_id: this.id,
        provider_type_id: null,
      });
    },

    providerProviderTypeRemove(i) {
      this.$swal
        .fire(msgConfirm("¿Confirma eliminar el registro?"))
        .then((resp) => {
          if (!resp.isConfirmed) return;

          const row = this.data.provider_provider_types[i];
          if (!row) return;

          if (row.id == null) this.data.provider_provider_types.splice(i, 1);
          else row.active = 0;
        });
    },

    // Emails
    emailAdd() {
      this.data.provider_emails.push({
        id: null,
        active: 1,
        email: "",
        provider_id: this.data.id,
        for_service: 1,
      });
    },

    emailDelete(i) {
      this.$swal
        .fire(
          msgConfirm(`¿Confirma eliminar el correo electrónico (${i + 1})?`),
        )
        .then((resp) => {
          if (!resp.isConfirmed) return;

          const row = this.data.provider_emails[i];
          if (!row) return;

          if (row.id === null) this.data.provider_emails.splice(i, 1);
          else row.active = 0;
        });
    },

    // Insurances
    providerInsuranceAdd() {
      this.data.provider_insurances.push({
        id: null,
        active: 1,
        provider_id: this.data.id,
        insurance_id: null,
        show_rhas: 0,
        show_bills: 0,
      });
    },

    providerInsuranceDelete(i) {
      this.$swal
        .fire(msgConfirm(`¿Confirma eliminar la aseguradora (${i + 1})?`))
        .then((resp) => {
          if (!resp.isConfirmed) return;

          const row = this.data.provider_insurances[i];
          if (!row) return;

          if (row.id === null) this.data.provider_insurances.splice(i, 1);
          else row.active = 0;
        });
    },

    // Provider Groups
    providerInGroupAdd() {
      if (!Array.isArray(this.data.provider_in_groups)) {
        this.data.provider_in_groups = [];
      }

      this.data.provider_in_groups.push({
        id: null,
        active: 1,
        provider_group_id: null,
        opening_discharge: false,
      });
    },

    providerInGroupDelete(i) {
      this.$swal
        .fire(msgConfirm(`¿Confirma eliminar el grupo (${i + 1})?`))
        .then((resp) => {
          if (!resp.isConfirmed) return;

          const row = this.data.provider_in_groups[i];
          if (!row) return;

          if (row.id === null) this.data.provider_in_groups.splice(i, 1);
          else row.active = 0;
        });
    },

    // Carga de catálogos en paralelo
    async loadCatalogs() {
      const token = this.login.token;

      const [
        entities,
        banks,
        formats,
        provider_types,
        days,
        provider_brands_resp,
        insurances_resp,
        provider_type_details_resp,
        provider_specialties_resp,
        provider_groups_resp,
      ] = await Promise.all([
        catalog("entities", token),
        catalog("banks", token),
        catalog("status_account_formats", token),
        catalog("provider_types", token),
        catalog("days", token),
        index("providers/brands", token, []),
        index("insurances", token, []),
        Axios.get(`${URL_API}/provider_type_details`, headersToken(token)),
        Axios.get(`${URL_API}/provider_specialties`, headersToken(token)),
        index("provider/groups", token, []),
      ]);

      this.entities = entities || [];
      this.entities_loading = false;

      this.banks = (banks || []).concat([this.banks_default_item]);
      this.banks_loading = false;

      this.status_account_formats = (formats || []).concat([
        this.status_account_format_default_item,
      ]);
      this.status_account_formats_loading = false;

      this.provider_types = provider_types || [];
      this.provider_types_ldg = false;

      this.days = days || [];
      this.days_loading = false;

      this.provider_brands = (provider_brands_resp?.data || []).concat([
        this.provider_brand_default_item,
      ]);
      this.provider_brands_loading = false;

      this.insurances = insurances_resp?.data || [];
      this.insurances_loading = false;

      this.provider_type_details = provider_type_details_resp?.data?.data || [];
      this.provider_type_details_ldg = false;

      this.provider_specialties = provider_specialties_resp?.data?.data || [];
      this.provider_specialties_ldg = false;

      this.provider_groups = provider_groups_resp?.data || [];
      this.provider_groups_loading = false;
    },

    // FAQs (no bloquea)
    loadFaqs() {
      Axios.get(
        `${URL_API}/faqs/faq_interfaces/${this.$route.meta.title}`,
        headersToken(this.login.token),
      )
        .then((resp) => {
          this.faqs = resp.data.data || [];
        })
        .catch((e) => console.log(e))
        .finally(() => {
          this.faqs_ldg = false;
        });
    },

    async loadItemIfEdit() {
      if (this.store_mode) return;

      this.loading = true;

      try {
        const response = await show(this.page_route, this.login.token, this.id);
        this.data = response;
        await this.getMunicipalities();
      } finally {
        this.loading = false;
      }
    },
  },

  async mounted() {
    try {
      this.loadFaqs();
      await this.loadCatalogs();
      await this.loadItemIfEdit();
    } catch (e) {
      console.log(e);

      // Asegura que no se quede “cargando” si truena
      this.entities_loading = false;
      this.banks_loading = false;
      this.status_account_formats_loading = false;
      this.provider_types_ldg = false;
      this.days_loading = false;
      this.provider_brands_loading = false;
      this.insurances_loading = false;
      this.provider_type_details_ldg = false;
      this.provider_specialties_ldg = false;
      this.provider_groups_loading = false;

      this.$swal.fire(
        msgAlert("error", "Error cargando catálogos del módulo."),
      );
    }
  },
};
</script>
